// DS2 — 섹션 머리(시안 .sh): <h2>제목</h2><span 부제> (kick-detail 2026-10-23 — 부제를 h2 밖으로) + 우측 「… →」 13 sub. ≤760: h2 18 · em 줄바꿈 12.
// ds4 A: 왼쪽 3px #1B2A4A 막대 + 패딩 12 · h2 18/700 · sortLabel = 같은 줄 정렬 라벨 12/700 #2F4B8A(「접수일 가까운 순」, ≤760 제목 아래 줄).
// 이모지·아이콘 장식 없음. 서버 컴포넌트(props 만). sortLabel 이 없으면 마크업은 종전 그대로.
import type { ReactNode } from 'react';
import './ds2.css';
import { listAnchor } from '@/lib/seo/anchor-text';

export interface SectionHeadProps {
  title: ReactNode;
  /** 「… →」 목적지. 없으면 링크를 내지 않는다. */
  moreHref?: string | null;
  /** 링크 문구. 기본 = 제목이 글자면 「{제목} 전체 보기 →」(레인 J ④ — 콘텐츠 링크에 뜻 없는 「전체 보기」 단독 금지) · 아니면 「전체 보기 →」. */
  moreLabel?: string;
  moreAriaLabel?: string;
  /** post1 3 — 링크 자리를 통째로 갈아 끼울 섬(예: 홈 지역 필터의 「{지역} N곳 →」). 있으면 moreHref·moreLabel 대신 이것을 낸다. */
  moreSlot?: ReactNode;
  /** 제목 옆 부제(13 mute · h2 밖 span — kick-detail). */
  sub?: ReactNode;
  /** 제목 태그. 기본 h2. 'div' = 같은 모양의 비-H2(role=heading aria-level=2 — 블로그 본문 밖 공통부 · blog-headings 2026-10-26). */
  as?: 'h2' | 'h3' | 'div';
  /** ds4 — 정렬 기준 라벨(예: 「접수일 가까운 순」). 제목 옆 같은 줄(≤760 다음 줄). 문구는 호출부가 정렬 함수와 같은 출처로 준다. */
  sortLabel?: string | null;
  id?: string;
  className?: string;
}

export default function SectionHead({ title, moreHref, moreLabel: moreLabelIn, moreAriaLabel, moreSlot, sub, as = 'h2', sortLabel, id, className }: SectionHeadProps) {
  const H = as;
  // 레인 J ④ — 기본 문구에 섹션 주제를 넣는다(lib/seo/anchor-text listAnchor 와 같은 꼴). 호출부가 준 문구는 그대로.
  const moreLabel = moreLabelIn ?? (typeof title === 'string' && title.trim() ? `${listAnchor(title)} →` : '전체 보기 →');
  const hProps = as === 'div' ? ({ role: 'heading', 'aria-level': 2 } as const) : {};
  const sl = typeof sortLabel === 'string' ? sortLabel.trim() : '';
  /* kick-detail (2026-10-23) — 부제는 h2 «밖» 이다. 종전 <h2>제목<em>부제</em></h2> 는 제목 텍스트가 「자주 묻는 질문신월3 재건축」·
   *   「함께 보는 현장해운대구」 로 붙어 읽혔다(검색엔진·스크린리더 · 소제목 목록). 겉모습은 같은 클래스 규칙(ds2.css .ds2-sh__sub)으로 유지. */
  const head = sub ? (
    <div className="ds2-sh__h">
      <H id={id} {...hProps}>{title}</H>
      <span className="ds2-sh__sub">{sub}</span>
    </div>
  ) : (
    <H id={id} {...hProps}>{title}</H>
  );
  return (
    <div className={className ? `ds2-sh ${className}` : 'ds2-sh'} data-ds2="section-head">
      {sl ? <div className="ds2-sh__l">{head}<span className="ds2-sh__sort" data-sort-label="">{sl}</span></div> : head}
      {moreSlot ?? (moreHref ? (
        <a href={moreHref} aria-label={moreAriaLabel}>{moreLabel}</a>
      ) : null)}
    </div>
  );
}
